function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m506.14 221.96-87.197-98.667c-1.898-2.148-4.627-3.378-7.493-3.378h-310.89c-2.866 0-5.595 1.23-7.493 3.378l-87.198 98.667c-2.604 2.947-3.239 7.146-1.623 10.732 0.609 1.352 1.497 2.52 2.577 3.453 0.021 0.023 0.037 0.049 0.058 0.073l241.64 272.42c1.898 2.14 4.621 3.364 7.481 3.364s5.583-1.225 7.481-3.364l241.64-272.42c0.021-0.023 0.038-0.049 0.058-0.073 1.079-0.933 1.967-2.102 2.577-3.453 1.616-3.586 0.981-7.785-1.623-10.732zm-112.42-82.046-44.441 71.644-71.22-71.644h115.66zm-65.659 78.668h-144.11l72.054-72.483 72.054 72.483zm-94.106-78.667-71.22 71.644-44.441-71.644h115.66zm-134.94 6.856 44.545 71.811h-108.01l63.463-71.811zm-63.295 91.811h118.18l81.636 225.26-199.81-225.26zm241.14 224.84 57.038-154.37c1.914-5.181-0.734-10.932-5.914-12.846-5.183-1.916-10.933 0.733-12.846 5.914l-59.035 159.78-80.931-223.32h301.13l-199.44 224.84zm91.603-244.84 44.545-71.811 63.463 71.811h-108.01z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m256 0c-5.522 0-10 4.477-10 10v51.513c0 5.523 4.478 10 10 10s10-4.477 10-10v-51.513c0-5.523-4.478-10-10-10z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m347.06 39.524c-3.905-3.905-10.235-3.905-14.143 0l-36.426 36.425c-3.905 3.905-3.905 10.237 0 14.142 1.954 1.953 4.513 2.929 7.072 2.929s5.118-0.977 7.071-2.929l36.426-36.425c3.905-3.905 3.905-10.237 0-14.142z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m213.56 75.949-36.425-36.425c-3.904-3.905-10.234-3.905-14.143 0-3.905 3.905-3.905 10.237 0 14.142l36.426 36.425c1.953 1.953 4.512 2.929 7.071 2.929s5.118-0.977 7.071-2.929c3.905-3.905 3.905-10.237 0-14.142z"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 337.43,
  cy: 268.36,
  r: 10
});

var SvgDiamond = function SvgDiamond(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    fill: "#FFF",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiamond, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/diamond.07b14726.svg";
export { ForwardRef as ReactComponent };